import DropIndicator from "./DropIndicator";
import { useSortable } from "@dnd-kit/sortable";

export const HIDDEN_DROPPABLE_ID = (skillType) => {
  return `hidden-droppable-${skillType}`;
};

function HiddenDroppable({ shouldDisplayIndicator, skillType }) {
  const id = HIDDEN_DROPPABLE_ID(skillType);

  const { attributes, listeners, setNodeRef, isOver } = useSortable({
    id,
  });

  const showIndicator = shouldDisplayIndicator || isOver;

  return (
    <div
      ref={setNodeRef}
      id={id}
      {...attributes}
      {...listeners}
      className={"hidden-droppable h-full self-center"}
    >
      {showIndicator && <DropIndicator />}
    </div>
  );
}

export default HiddenDroppable;
